import { memo } from "react";
import SaveButton from "@/components/SaveButton";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";

const ProjectSchedulesAddSchedulesSubmitButtonComponent = () => {
  const selectedCount = useRowSelectionCount();

  return <SaveButton disabled={selectedCount === 0} />;
};

export const ProjectSchedulesAddSchedulesSubmitButton = memo(
  ProjectSchedulesAddSchedulesSubmitButtonComponent,
);
